// extracted by mini-css-extract-plugin
export var input = "ToggleButton-module--input--ZYR49";
export var label = "ToggleButton-module--label--XONIP";